<loading [visible]="loading()"></loading>

@if(!loading()){
<app-custom-modal customTitle="Dimensiones y Cantidades" (closeFunction)="closeFormFunction()"
    (acceptFunction)="saveEntity()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="w-full">

        <div formArrayName="measuresArray" class="grid grid-cols-3 gap-2">
            @for (item of measuresArray.controls; track $index) {
            <div [formGroupName]="$index"
                class="flex flex-col gap-2 p-6 bg-white border border-slate-200 rounded-xl shadow-sm transition-all">

                <custom-input label="Cantidad" class="text-slate-900 font-bold" [autofocus]="$index === measuresArray.controls.length - 1"
                    [formControlItem]="item.get('quantity')"></custom-input>
                <custom-input label="Altura" class="text-slate-900"
                    [formControlItem]="item.get('height')"></custom-input>
                <custom-input label="Anchura" class="text-slate-900"
                    [formControlItem]="item.get('width')"></custom-input>
                <custom-input label="Grosor" class="text-slate-900"
                    [formControlItem]="item.get('thickness')"></custom-input>

                <button type="button" (click)="removeItem($index)" [disabled]="measuresArray.length === 1"
                    class="cursor-pointer group flex items-center justify-center p-1 rounded-full border border-slate-100 hover:border-red-200 hover:bg-red-50 transition-all disabled:opacity-0">
                    <span class="text-slate-400 group-hover:text-red-500 transition-colors ">
                        Eliminar
                    </span>
                </button>
            </div>
            }
        </div>

        <div class="mt-8 flex justify-center">
            <button type="button" (click)="addItem()"
                class="group flex items-center gap-3 px-6 py-3 bg-blue-600 border-2 border-blue-600 text-white rounded-full hover:bg-blue-500 hover:border-blue-500 transition-all duration-300 font-semibold shadow-lg shadow-blue-900/20 active:scale-95">
                <span class="text-xl group-hover:rotate-90 transition-transform duration-300">+</span>
                Añadir otra línea de medida
            </button>
        </div>
    </form>

</app-custom-modal>
}